<template>
    <div class="my-mbinfo">
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow :fixed="true">
        </van-nav-bar>
        <div>
            <van-cell-group custom-class="goods-cell-group">
                <van-cell is-link style="height: 63px;">
                    <div class="mbinfo-titel">
                        <div style="width: 80%;">
                            <van-uploader :after-read="onRead" accept="image/jpeg">
                                头像
                            </van-uploader>
                        </div>
                        <div style="height: 40px;width: 40px;text-align: right" @click="totwo(headPortrait)">
                            <img :src="headPortrait" v-if="headPortrait" style="width: 37px;height: 37px;">
                            <img src="./../../assets/touxiang.png" v-if="!headPortrait"
                                 style="width: 37px;height: 37px;">
                        </div>
                    </div>
                </van-cell>
            </van-cell-group>
            <van-cell-group custom-class="goods-cell-group">
                <van-cell @click="toUpdateMember('nc',memberName)" is-link>
                    <div class="mbinfo-titel">
                        <span style="font-size: 12px">昵称</span>
                        <span style="font-size: 12px">{{memberName}}</span>
                    </div>
                </van-cell>
            </van-cell-group>
            <van-cell-group custom-class="goods-cell-group">
                <van-cell @click="toUpdateMember('sr',srDate)" is-link>
                    <div class="mbinfo-titel">
                        <span style="font-size: 12px">生日</span>
                        <span style="font-size: 12px">{{srDate}}</span>
                    </div>
                </van-cell>
            </van-cell-group>
            <van-cell-group custom-class="goods-cell-group">
                <van-cell @click="toUpdateMember('sjh',phone)" is-link>
                    <div class="mbinfo-titel">
                        <span style="font-size: 12px">手机号</span>
                        <span style="font-size: 12px">{{phone}}</span>
                    </div>
                </van-cell>
            </van-cell-group>
        </div>

        <van-popup v-model="infoShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false"
                   style="height: 55%;">
             <span class="md-bt">
                    <span @click="guanbi">返回</span>
                    <span @click="updateMember">保存</span>
             </span>
            <div>
                <van-cell-group v-if="type=='nc'">
                    <van-field v-model="memberNameTmp" placeholder="请输入昵称"/>
                </van-cell-group>
                <van-cell-group v-if="type=='sr'" @click="dateClick">
                    <van-cell is-link>
                        {{srDateTmp}}
                    </van-cell>
                </van-cell-group>
                <van-cell-group v-if="type=='sjh'">
                    <van-field v-model="phoneTmp" placeholder="请输入手机号"/>
                </van-cell-group>
            </div>
        </van-popup>

        <van-popup v-model="showPicker" position="bottom" :overlay="true">
            <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @confirm="onConfirm"
                    @cancel="showPicker = false"/>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie} from "../../utils/auth";
    import {ImagePreview} from 'vant';

    export default {
        data() {
            return {
                title: '个人资料',
                deptId: '',
                token: '',
                member: {},
                memberId: '',
                headPortrait: '',
                memberName: '',
                srDate: '',
                phone: '',
                memberNameTmp: '',
                srDateTmp: '',
                phoneTmp: '',
                type: '',
                infoShow: false,

                showPicker: false,
                minDate: new Date(1900, 0, 1),
                maxDate: new Date(),
                currentDate: new Date(),
            };
        },
        async created() {
            document.title = "完善信息"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.getMemberInfo()
        },

        methods: {

            dateClick() {
                this.showPicker = true
                this.minDate = new Date(1990, 0, 1)
                this.maxDate = new Date()
            },

            onConfirm(val) {
                var year = val.getFullYear();     //获取年份
                var month = val.getMonth() + 1;    //获取月份
                var day = val.getDate();          //获取日期
                var yyyymmdd = year + "-" + month + "-" + day;  //拼接成yyyymmdd形式字符串
                this.srDateTmp = yyyymmdd ,
                this.showPicker = false
            },

            async onRead(file) {
                let formData = new FormData();
                formData.append('file', file.file);
                let res = await this.$fileUpload("/fw/uploadHeadImg/" + this.memberId, formData)
                if (res.code == 200) {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: '#1989fa'
                    });
                    this.getMemberInfo()
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },

            totwo(headPortrait) {
                var url = './../../assets/touxiang.png'
                if (headPortrait) {
                    url = headPortrait
                }
                var arr = []
                arr.push(url)
                ImagePreview({
                    images: arr,
                    startPosition: 0,
                    loop: false, //是否开启循环
                    closeable: true,
                    closeIconPosition: 'top-left'
                });
            },

            toUpdateMember(type, val) {
                this.infoShow = true
                this.type = type
                if (this.type == 'nc') {
                    this.memberNameTmp = val
                }
                if (this.type == 'sr') {
                    this.srDateTmp = val
                }
                if (this.type == 'sjh') {
                    this.phoneTmp = val
                }
            },

            async updateMember() {
                let data = {
                    id: this.memberId
                }
                if (this.type == 'nc') {
                    data.memberName = this.memberNameTmp
                    if (!this.memberNameTmp) {
                        this.$notify({type: 'danger', message: '请输入昵称'});
                        return;
                    }
                }
                if (this.type == 'sr') {
                    data.dateStr = this.srDateTmp
                    if (!this.srDateTmp) {
                        this.$notify({type: 'danger', message: '请选择生日'});
                        return;
                    }
                }
                if (this.type == 'sjh') {
                    if (!this.phoneTmp) {
                        this.$notify({type: 'danger', message: '请输入手机号'});
                        return;
                    }
                    var strTemp = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
                    let b = strTemp.test(this.phoneTmp)
                    if (!b) {
                        this.$notify({type: 'danger', message: '请输入正确的手机号'});
                        return;
                    }
                    data.phone = this.phoneTmp
                }
                let res = await this.$post("/fw/updateFwMember", data)
                if (res.code == 200) {
                    if (this.type == 'nc') {
                        this.memberName = this.memberNameTmp
                    }
                    if (this.type == 'sr') {
                        this.srDate = this.srDateTmp
                    }
                    if (this.type == 'sjh') {
                        this.phone = this.phoneTmp
                    }
                    this.$notify({type: 'success', message: res.message});
                    this.guanbi()
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },
            guanbi() {
                this.infoShow = false
            },
            async getMemberInfo() {
                let data = {
                    token: this.token
                }
                let res = await this.$get("/fw/getFwTyMember", data)
                this.memberId = res.member.id
                this.headPortrait = res.member.headPortrait
                this.memberName = res.member.memberName
                this.srDate = res.member.birthdayStr
                this.phone = res.member.phone
            },

            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>

    .my-mbinfo {
        margin: 0 auto;
        height: 100%;
        position: relative;
        background-color: #EEEEEE;
        padding-top: 53px;
    }

    .mbinfo-titel {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 40px;
    }

    .van-cell__right-icon {
        margin: auto;
        margin-left: 0.10667rem;
        color: #969799;
    }

    ::v-deep .van-uploader__input {
        position: absolute;
        top: 0;
        left: 0;
        width: 280px;
        height: 100%;
        overflow: hidden;
        cursor: pointer;
        opacity: 0;
    }

    .md-bt {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        font-size: 13px;
        border-bottom: #dddddd solid 1px;
        padding: 10px;
    }

    .mb-update {
        margin: 0 auto;
        height: 100%;
        position: relative;
        background-color: #EEEEEE;
        padding-top: 50px;
    }

    ::v-deep .van-field__control {
        display: block;
        box-sizing: border-box;
        width: 100%;
        min-width: 0;
        margin: 0;
        padding: 0;
        color: #323233;
        line-height: inherit;
        text-align: left;
        background-color: transparent;
        border: 0;
        resize: none;
        border-bottom: #dddddd solid 1px;
    }

</style>
